import axios from 'axios';

// Create axios instance with configuration
const instance = axios.create({
  baseURL: process.env.NODE_ENV === 'development' 
    ? 'http://localhost:5000' 
    : 'https://api.narrowgatepath.com',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add response interceptor for handling token expiration
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    // If unauthorized, redirect to login page
    if (error.response?.status === 401) {
      window.location.href = '/admin';
    }
    return Promise.reject(error);
  }
);

export default instance;
